import type React from 'react';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';

import { Button } from 'ui-components/components/button';
import { FlexColumn } from 'ui-components/components/flex/column';
import { FlexRow } from 'ui-components/components/flex/row';
import { Gap } from 'ui-components/components/flex/gap';
import { Text } from 'ui-components/components/text';
import { TextType } from 'ui-components/components/text/text-type';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { messages } from './messages';
import styles from './styles.module.less';
import commonStyles from '../../../settings-page.module.less';

const BENEFIT_MESSAGES = [messages.benefit1, messages.benefit2, messages.benefit3];

type WorkflowsEmptyStateProps = {
  onCreateWorkflow: () => void;
};

export const WorkflowsEmptyState: React.FC<WorkflowsEmptyStateProps> = ({ onCreateWorkflow }) => {
  return (
    <FlexRow className={styles['empty-state']} gap={Gap.Space24}>
      <FlexColumn gap={Gap.Space12}>
        <Text className={commonStyles['header-level-3']} textType={TextType.H3} value={messages.emptyStateTitle} />
        <Text textType={TextType.Paragraph} value={messages.emptyStateDescription} />
        <Text textType={TextType.Label} value={messages.benefitsTitle} />
        {BENEFIT_MESSAGES.map((message) => (
          <FlexRow key={message.id} className={styles['benefit-item']} gap={Gap.Space8}>
            <FontAwesomeIcon className={styles['check-icon']} icon={faCheck} />
            <Text textType={TextType.Paragraph} value={message} />
          </FlexRow>
        ))}
        <FlexRow className={styles['benefit-item']}>
          <Button onClick={onCreateWorkflow} theme={THEME_CONSTANTS.primary}>
            <FormattedMessage {...messages.createButton} />
          </Button>
        </FlexRow>
      </FlexColumn>
    </FlexRow>
  );
};
